import React, { PropTypes } from 'react';
import { FontIcon, Paper } from 'material-ui';
import { prop, equals, isEmpty } from 'ramda';

const SupplierLeftBarMembership = props => {
  const {
    isEditable,
    profileToShow,
  } = props;
  if (isEmpty(profileToShow.companyBadges)) return <div/>;
  return (
    <div>
      <Paper style={{ marginTop: '30px' }}>
        <div style={{ backgroundColor: '#f5f5f5' }}>
          <h4 style={{ marginLeft: '15px', paddingBottom: '7%', lineHeight: '0.7' }}>Industry Memberships</h4>
        </div>
        {
          profileToShow.companyBadges && profileToShow.companyBadges.filter(org => org.verifiedStatus === 'verified').length > 0 && !isEditable ?
            <div style={{ height: '100%', padding: '0 10px 20px 10px', textAlign: 'center' }}>
              {
                profileToShow.companyBadges.filter(({ verifiedStatus }) => verifiedStatus === 'verified').sort((a, b) => {
                  if (a.badgeId === '5ec074e495512b0156baf64f') return -1;
                  if (a.name < b.name) return -1;
                  if (a.name > b.name) return 1;
                  return 0;
                }).map((membership, index) => (
                  <div
                    className="verified-member-block"
                    style={{ textAlign: 'center', padding: '2px', margin: '7px 10px 0 0', verticalAlign: 'top', overflow: 'hidden' }}
                    key={index}
                  >
                    <img src={membership.logo} height={membership.name === 'European Tourism Association (ETOA)' ? '30px' : '40px'}/><br/>
                    <span>
                      <FontIcon
                        className="tc-icon-check"
                        color="#00bcd4"
                        style={{ fontSize: '10px' }}
                      />
                      <span style={{ color: '#00bcd4', fontSize: '10px' }}>Verified Member</span>
                    </span>
                    {
                      membership.website ?
                        <div className="what-is-org-hover" style={{ marginTop: '-10px', textAlign: 'center' }}>
                          <span style={{ color: '#00bcd4', fontSize: '10px' }}>
                            What is <a href={prop('website', membership)} style={{ color: '#ff4081' }} target="_blank">{membership.acronym ? membership.acronym : membership.name}</a>?
                          </span>
                        </div> : <span/>
                    }
                  </div>
                ))
              }
            </div> : <span/>
        }
      </Paper>
    </div>
  );
};

SupplierLeftBarMembership.propTypes = {
  isEditable: PropTypes.bool,
  profileToShow: PropTypes.object,
};

export default SupplierLeftBarMembership;



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-left-bar/memberships.jsx